exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[role=button],[role=tab],a,button{cursor:pointer}html[dir] input,html[dir] textarea{-webkit-box-shadow:none!important;box-shadow:none!important}.t2NriCog4TsEUCIXEr0AZA\\=\\={display:-webkit-box;display:-ms-flexbox;display:flex}.VTZJSbqVhIwbSfSSrWOJIA\\=\\={font-size:11px;display:inline-block;-ms-flex-item-align:center;align-self:center;color:#767676}html[dir] .VTZJSbqVhIwbSfSSrWOJIA\\=\\={margin:0 8px}", ""]);
// Exports
exports.locals = {
	"timing": "t2NriCog4TsEUCIXEr0AZA==",
	"inlineIcon": "VTZJSbqVhIwbSfSSrWOJIA=="
};